import project01_image0 from "../assets/img/kansysEdge.jpg";
import project01_image01 from "../assets/img/Aliv1.jpg";
import project01_image02 from "../assets/img/Aliv2.jpg";
import project01_image03 from "../assets/img/Aliv3.jpg";


import project02_image0 from "../assets/img/dataSource.png";
import project02_image00 from "../assets/img/datasource/00.png";
import project02_image01 from "../assets/img/datasource/01.png";
import project02_image02 from "../assets/img/datasource/02.png";
import project02_image03 from "../assets/img/datasource/03.png";
import project02_image04 from "../assets/img/datasource/04.png";
import project02_image05 from "../assets/img/datasource/05.png";
import project02_image06 from "../assets/img/datasource/06.png";
import project02_image07 from "../assets/img/datasource/07.png";
import project02_image08 from "../assets/img/datasource/08.png";
import project02_image09 from "../assets/img/datasource/09.png";
import project02_image10 from "../assets/img/datasource/10.png";


import project03_image0 from "../assets/img/githubicon.png";


import project04_image00 from "../assets/img/first american logo.jpg";

import project04_image01 from "../assets/img/cover1.gif";
import project04_image02 from "../assets/img/coverpage.PNG";

import project04_image03 from "../assets/img/document-uploads-page.gif";


import project05_image00 from "../assets/img/go-local-logo.jfif";
import project05_image01 from "../assets/img/storage-essentials.png";
import project05_image02 from "../assets/img/central-self-storage-image.PNG";
import project05_image03 from "../assets/img/istorage.PNG";
import project05_image04 from "../assets/img/advantage-storage.PNG";
import project05_image05 from "../assets/img/selfStorage.PNG";


import project06_image00 from "../assets/img/education-logo-columbia-university.webp";

import project06_image01 from "../assets/img/columbia-university-website-screenshot.jpg"
import project06_image02 from "../assets/img/columbia-1.jpg"
import project06_image03 from "../assets/img/columbia-2.jpg"
import project06_image04 from "../assets/img/columbia-3.jpg"

import project07_image00 from "../assets/img/federal-reserve-bank-of-st-louis.jpg"
 

import project07_image01 from "../assets/img/fed/fedReserve-1.png";
import project07_image02 from "../assets/img/fed/fedReserve-2.png";
import project07_image03 from "../assets/img/fed/fedReserve-3.png";
import project07_image04 from "../assets/img/fed/fedReserve-4.png";
import project07_image05 from "../assets/img/fed/fedReserve-5.png";
import project07_image06 from "../assets/img/fed/fedReserve-6.png";
import project07_image07 from "../assets/img/fed/fedReserve-7.png";
import project07_image08 from "../assets/img/fed/fedReserve-8.png";
import project07_image09 from "../assets/img/fed/fedReserve-9.png";
import project07_image10 from "../assets/img/fed/fedReserve-10.png";
import project07_image11 from "../assets/img/fed/fedReserve-11.png";



const projects = [
  {
    id: "project-angular-task",
    imageName: project03_image0,
    mainHeader: "Angular Task Project",
    description: `The project is built with Angular, Angular Material, and Angular CLI. \n
    This project is a task management application built with Angular. It allows users to create, edit, and delete tasks. \n
    The project is deployed to GitHub Pages. \n
    The project is a single page application that allows users to create, edit, and delete tasks. \n
    The project also has the ability to search for Movies and display the results on the same page. \n
    Add movies to a favorites list and view the list of favorites. \n
    Favorite movies can be reordered and deleted from the favorites list. \n
    Favorite movies can be emailed to another user. \n
    The project is a responsive application built with PrimeNG that allows users to create, edit, and delete tasks on any device. \n
    
    Features include: \n
    - Task creation and management \n
    - Real-time updates \n
    - Responsive design \n
    - GitHub Pages deployment \n
    Visit the live demo by clicking the PROJECTS menu item at the top of the page or visiting this web address: https://jmbwoody.github.io/AngularTaskProject/`,
    upperClassNames: "col-lg-4 col-md-6 item web",
    classNames: "item-img mb-30 mb-sm-50 wow fadeInLeft",
    images: []
  },
  {
    id: "project-07",
    imageName: project07_image00,
    mainHeader: "Federal Reserve Bank of St. Louis",
    description: `Senior Software Engineer \n    
    Developed and maintained dynamic web applications using Angular and Spring Boot, enhancing user experience and performance. \n    
    Collaborated with cross-functional teams to gather requirements and deliver solutions that meet client specifications.  \n    
    Implemented AWS services for scalable application hosting, including EC2 for computing and S3 for storage solutions. \n    
    Designed RESTful APIs for seamless integration between front-end and back-end services, ensuring data consistency and reliability. \n    
    Enhanced the user experience by integrating the US Web Design System (USWDS) into Angular front-end, utilizing SASS for theming. \n
    Deployed services to AWS Elastic Container Service (ECS) using Docker containers and Gitlab pipeline. \n
    Worked closely with the QA team to troubleshoot and resolve issues, enhancing product reliability by adding API testing functionality using Xray for managing test cases and Cucumber for implementing behavior-driven development (BDD). \n
    `,
    upperClassNames: "col-lg-4 col-md-6 item web",
    classNames: "item-img mb-30 mb-sm-50 wow fadeInLeft",
    images: [ 
      {
        imageName: project07_image01,
        upperClassNames: "col-lg-4 col-md-6 item web",
        classNames: "item-img mb-30 mb-sm-50 wow fadeInLeft"
      },
      
      {
        imageName: project07_image03,
        upperClassNames: "col-lg-4 col-md-6 item web",
        classNames: "item-img mb-30 mb-sm-50 wow fadeInLeft"
      },
      {
        imageName: project07_image04,
        upperClassNames: "col-lg-4 col-md-6 item web",
        classNames: "item-img mb-30 mb-sm-50 wow fadeInLeft"
      },
      {
        imageName: project07_image05,
        upperClassNames: "col-lg-4 col-md-6 item web",
        classNames: "item-img mb-30 mb-sm-50 wow fadeInLeft"
      },
      {
        imageName: project07_image06,
        upperClassNames: "col-lg-4 col-md-6 item web",
        classNames: "item-img mb-30 mb-sm-50 wow fadeInLeft"
      },
      {
        imageName: project07_image07,
        upperClassNames: "col-lg-4 col-md-6 item web",
        classNames: "item-img mb-30 mb-sm-50 wow fadeInLeft"
      },
      {
        imageName: project07_image08,
        upperClassNames: "col-lg-4 col-md-6 item web",
        classNames: "item-img mb-30 mb-sm-50 wow fadeInLeft"
      },
      {
        imageName: project07_image09,
        upperClassNames: "col-lg-4 col-md-6 item web",
        classNames: "item-img mb-30 mb-sm-50 wow fadeInLeft"
      },
      {
        imageName: project07_image02,
        upperClassNames: "col-lg-4 col-md-6 item web",
        classNames: "item-img mb-30 mb-sm-50 wow fadeInLeft"
      },
      {
        imageName: project07_image10,
        upperClassNames: "col-lg-4 col-md-6 item web",
        classNames: "item-img mb-30 mb-sm-50 wow fadeInLeft"
      },
      {
        imageName: project07_image11,
        upperClassNames: "col-lg-4 col-md-6 item web",
        classNames: "item-img mb-30 mb-sm-50 wow fadeInLeft"
      }
    ]
  },
  {
    id: "project-06",
    imageName: project06_image00,
    mainHeader: "Columbia University",
    description: `Front-End Drupal Developer \n     
      Developed and maintained multiple Drupal websites, focusing on news and media content management.\n    
      Designed and implemented responsive themes that enhanced user engagement and accessibility across devices. \n    
      Streamlined the process for posting and managing news articles, resulting in a 25% reduction in publication time\n    
      Collaborated with editors and content creators to optimize article layouts and improve overall readability. \n    
      Integrated SEO best practices to increase organic traffic by utilizing BrightEdge SEO to optimize online presence and improve search visibility. 
    `,
    upperClassNames: "col-lg-4 col-md-6 item web",
    classNames: "item-img mb-30 mb-sm-50 wow fadeInLeft",
    images: [
      {
        imageName: project06_image01,
        upperClassNames: "col-lg-3 col-md-3 item web",
        classNames: "item-img mb-30 mb-sm-50 wow fadeInLeft"
      },
      {
        imageName: project06_image02,
        upperClassNames: "col-lg-3 col-md-3 item web",
        classNames: "item-img mb-30 mb-sm-50 wow fadeInLeft"
      },
      {
        imageName: project06_image03,
        upperClassNames: "col-lg-3 col-md-3 item web",
        classNames: "item-img mb-30 mb-sm-50 wow fadeInLeft"
      },
      {
        imageName: project06_image04,
        upperClassNames: "col-lg-3 col-md-3 item web",
        classNames: "item-img mb-30 mb-sm-50 wow fadeInLeft"
      }  
    ]
  },
  {
    id: "project-04",
    imageName: project04_image00,
    mainHeader: "First American Title",
    description: `ClarityFirst App\nSoftware Engineer III  - Sr. Front-End Developer \n  
      Worked as a full-stack Software Engineer focusing in React Front-end development on the desktop web app ClairtyFirst, the first end-to-end digital solution for commercial and residential real estate transactions.  \n
      Responsible for interface implimentation and integrating web applications with application tier or with backend databases.  \n    
      Hands on expertise in front-end development utilizing Javascript framework React.JS with Hooks, TypeScript, and the React Testing Library.  \n    
      Experience in Node.JS, Github, Docker, Visual Studio, .NET, AJAX, RESTful APIs, Postman, Swagger, Github, Azure DevOps, and Figma Studio,     \n    
      Experience in using Node.JS and GIT version control tools such as GitKraken for Github repository managment.   \n    
      Experience in implempenting Component life cycle architecture, store actions, using socket.io in React-Redux app to handle real time data,      
      installing React Router, ThunkRedux for API Calls in React JS. \n
      Experience in developing style components with LESS & SASS.     \n
      Involved in all the stages of Software Development Life Cycle including Requirements, Analysis and Design, Implementation, Integration and      
      Testing, Depoloyment and Maintenance.  
    `,
    upperClassNames: "col-lg-4 col-md-6 item web",
    classNames: "item-img mb-30 mb-sm-50 wow fadeInLeft",
    images: [
      {
        imageName: project04_image01,
        upperClassNames: "col-lg-4 col-md-6 item web",
        classNames: "item-img mb-30 mb-sm-50 wow fadeInLeft"
      },
      {
        imageName: project04_image02,
        upperClassNames: "col-lg-4 col-md-6 item graphic",
        classNames: "item-img mb-30 mb-sm-50 wow fadeInUp "
      },
      {
        imageName: project04_image03,
        upperClassNames: "col-lg-4 col-md-6 item brand",
        classNames: "item-img mb-30 mb-sm-50 wow fadeInRight"
      }
    ]
  },
  {
    id: "project-05",
    imageName: project05_image00,
    mainHeader: "Go Local Interactive",
    description: `Software Engineer III  - UI/UX Application Developer \n    
    Build and Maintained over 40 bitbucket repositories with GIT that contain Go Local's client websites. \n
    Designed and developed new functionality for multiple client's websites in PHP, Javascript, HTML, and CSS. \n
    Responsibilities included creating and maintaining the storage essentials platform, it is created with Vue JS. \n
    I integrated GoLocal's clients Wordpress sites with a more robust SaaS named "Storage Essentials".   
    `,
    upperClassNames: "col-lg-4 col-md-6 item web",
    classNames: "item-img mb-30 mb-sm-50 wow fadeInLeft",
    images: [
      {
        imageName: project05_image00,
        upperClassNames: "col-lg-4 col-md-6 item web",
        classNames: "item-img mb-30 mb-sm-50 wow fadeInLeft"
      },
      {
        imageName: project05_image01,
        upperClassNames: "col-lg-4 col-md-6 item graphic",
        classNames: "item-img mb-30 mb-sm-50 wow fadeInUp "
      },
      {
        imageName: project05_image02,
        upperClassNames: "col-lg-4 col-md-6 item brand",
        classNames: "item-img mb-30 mb-sm-50 wow fadeInRight"
      },
      {
        imageName: project05_image03,
        upperClassNames: "col-lg-4 col-md-6 item brand",
        classNames: "item-img mb-30 mb-sm-50 wow fadeInRight"
      },
      {
        imageName: project05_image04,
        upperClassNames: "col-lg-4 col-md-6 item brand",
        classNames: "item-img mb-30 mb-sm-50 wow fadeInRight"
      },
      {
        imageName: project05_image05,
        upperClassNames: "col-lg-4 col-md-6 item brand",
        classNames: "item-img mb-30 mb-sm-50 wow fadeInRight"
      },
    ]
  },
  {
    id: "project-01",
    imageName: project01_image0,
    mainHeader: "Aliv",
    description: `Sr. Front-End Developer - UI/UX Application Developer \n
    I Worked with client Aliv, a phone company located in the Bahamas to develop a new fully functional customer facing app for Android and Iphone that is fully compatible with all mobile devices. \n
    I created the app for customers to login and pay bills, add minutes and data to their account, transfer money, receive notifications, and gift items to other phone accounts. Users that have corporate access can also view all of their corporate accounts from one portal in a fully functional mobile app. \n
    Developed a new billing app that is used for updating Kansys clients billing portals. \n
    The Aliv client required the use of Visual Studio in a .Net environment making use of  Javascript ES5 (for backward capability), HTML, and CSS.\n
    For the new Edge billing application, I developed in a full-stack environment using Node, JS, Webpack, React JS, Github, and Sourcetree. \n
    `,
    upperClassNames: "col-lg-4 col-md-6 item web",
    classNames: "item-img mb-30 mb-sm-50 wow fadeInLeft",
    images: [
      {
        imageName: project01_image01,
        upperClassNames: "col-lg-4 col-md-6 item web",
        classNames: "item-img mb-30 mb-sm-50 wow fadeInLeft"
      },
      {
        imageName: project01_image02,
        upperClassNames: "col-lg-4 col-md-6 item graphic",
        classNames: "item-img mb-30 mb-sm-50 wow fadeInUp "
      },
      {
        imageName: project01_image03,
        upperClassNames: "col-lg-4 col-md-6 item brand",
        classNames: "item-img mb-30 mb-sm-50 wow fadeInRight"
      }
    ]
  },
  {
    id: "project-02",
    imageName: project02_image0,
    mainHeader: "Data Source",
    description: `Front-End Developer - UI/UX Application Developer 
    Created a new client UI for websites based on photoshop templates. \n
    Maintain over 50 websites in a CMS (MarcomCentral) by updating outdated UI with CSS3, HTML5, jQuery, and Javascript. Bridge the gap between the CMS and the .Net environment by creating Iframes for custom content. \n
    Use of an internally built engine (Brand Manager) to create complex form driven HTML5/CSS3 applications with the ability to display and validate accurate data transmission to the server with the use of Javascript and Jquery. \n
    Utilize Javascript object oriented programming. Analyze multi-dimensional data arrays to assign user access and requirements for specific user data-driven forms. \n
    Utilize jQuery to miniplate server side code for client specific UI and business requirements. \n
    Use of Visual Studio in a .Net environment. As a front-end developer, I code with HTML5, CSS3, JavaScript, and jQuery to create interactive design with a secure, valid, and accurate data transmission to the back-end.\n
    `,
    upperClassNames: "col-lg-4 col-md-6 item web",
    classNames: "item-img mb-30 mb-sm-50 wow fadeInLeft",
    images: [
      {
        imageName: project02_image00,
        upperClassNames: "col-lg-4 col-md-6 item web",
        classNames: "item-img mb-30 mb-sm-50 wow fadeInLeft"
      },
      {
        imageName: project02_image01,
        upperClassNames: "col-lg-4 col-md-6 item graphic",
        classNames: "item-img mb-30 mb-sm-50 wow fadeInUp "
      },
      {
        imageName: project02_image02,
        upperClassNames: "col-lg-4 col-md-6 item brand",
        classNames: "item-img mb-30 mb-sm-50 wow fadeInRight"
      },
      {
        imageName: project02_image03,
        upperClassNames: "col-lg-4 col-md-6 item graphic",
        classNames: "item-img mb-md-30 mb-sm-50 wow fadeInLeft"
      },
      {
        imageName: project02_image04,
        upperClassNames: "col-lg-4 col-md-6 item brand",
        classNames: "item-img mb-sm-50 wow fadeInUp"
      },
      {
        imageName: project02_image05,
        upperClassNames: "col-lg-4 col-md-6 item web",
        classNames: "item-img wow fadeInRight"
      },
      {
        imageName: project02_image06,
        upperClassNames: "col-lg-4 col-md-6 item web",
        classNames: "item-img mb-30 mb-sm-50 wow fadeInLeft"
      },
      {
        imageName: project02_image07,
        upperClassNames: "col-lg-4 col-md-6 item graphic",
        classNames: "item-img mb-30 mb-sm-50 wow fadeInUp "
      },
      {
        imageName: project02_image08,
        upperClassNames: "col-lg-4 col-md-6 item brand",
        classNames: "item-img mb-30 mb-sm-50 wow fadeInRight"
      },
      {
        imageName: project02_image09,
        upperClassNames: "col-lg-4 col-md-6 item graphic",
        classNames: "item-img mb-30 mb-sm-50 wow fadeInUp "
      },
      {
        imageName: project02_image10,
        upperClassNames: "col-lg-4 col-md-6 item brand",
        classNames: "item-img mb-30 mb-sm-50 wow fadeInRight"
      }
    ]
  },
  {
    id: "project-03",
    imageName: project03_image0,
    mainHeader: "My Git Hub Repo",
    description: `Here you can find my GitHub Repository with my latest additions \n https://github.com/jmbwoody`,
    upperClassNames: "col-lg-4 col-md-6 item web",
    classNames: "item-img mb-30 mb-sm-50 wow fadeInLeft",
    images: [
      
    ]
  }
];

export default projects;
